// DocumentMeta.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSiteTitleDesc from "../../hooks/useSiteTitleDesc";

const DocumentMeta = ({ pageTitle, pageDescription } = {}) => {
  const { data, isLoading, error } = useSiteTitleDesc();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !error) {
      const baseTitle = data?.siteTitle || "Default Title";
      const baseDesc = data?.siteDescription || "Default Description";

      document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;

      const metaDescription =
        document.querySelector('meta[name="description"]') ||
        document.createElement("meta");
      if (!metaDescription.parentNode) {
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", pageDescription || baseDesc);
    }
  }, [data, isLoading, error, pageTitle, pageDescription, location]);

  return null;
};

export default DocumentMeta;
